module.exports = "https://web-assets.ifttt.com/packs/media/perks/chart-27d35494.svg";